export default "__VITE_ASSET__d661026f__"